import angular from "angular";
import {
  conversionModalComponentOptions,
  ConversionModalService,
  vsName as conversionModalComponentOptionsName,
  vsServiceName as conversionModalServiceName,
} from "./conversionModal";
import {
  MachinesChangeViewComponentOptions,
  MachinesChangeViewModalService,
  vsComponentName as MachinesChangeViewComponentOptionsName,
  vsServiceName as MachinesChangeViewModalServiceName,
} from "./changeDetailsModel";
import {
  lookupManagementComponentOptions,
  LookupManagementServiceProvider,
  vsComponentName as lookupManagementComponentOptionsName,
  vsServiceName as LookupManagementServiceName,
} from "./lookupManagement";
import {
  machineConfigurationGridComponentOptions,
  vsComponentName as machineConfigurationGridComponentOptionsName,
} from "./machineConfigurationGrid";
import {
  MachineConfigurationViewComponentOptions,
  vsName as MachineConfigurationViewComponentOptionsName,
} from "./machineConfigurationView";
import {
  machineDetailsTabsComponentOptions,
  MachineDetailTabsProvider,
  vsName as machineDetailsTabsComponentOptionsName,
  vsServiceName as machineDetailTabsServiceName,
} from "./machineDetailTabs";
import {
  machineEditFormComponentOptions,
  vsComponentName as machineEditFormComponentOptionsName,
} from "./machineEditForm";


import {
  selectMachineModalComponentOptions,
  SelectMachineModalService,
  vsComponentName as selectMachineModalComponentOptionsName,
  vsServiceName as selectMachineModalServiceName,
} from "./selectMachineModal";

import { vsModuleName as progressivesModuleName } from "./progressives/module";
import { lookupManagementComponentConfig } from "./lookupManagement/config";
import {
  lookupModalComponentOptions,
  LookupModalService,
  vsComponentName as lookupModalComponentOptionsName,
  vsServiceName as LookupModalServiceName,
} from "./lookupModal";

export const vsModuleName = "SlotTrak.Machines.Components";

angular
  .module(vsModuleName, ["records", progressivesModuleName])
  .config(lookupManagementComponentConfig)
  .component(
    conversionModalComponentOptionsName,
    conversionModalComponentOptions
  )
  .component(
    lookupManagementComponentOptionsName,
    lookupManagementComponentOptions
  )
  .component(
    machineConfigurationGridComponentOptionsName,
    machineConfigurationGridComponentOptions
  )
  .component(
    MachineConfigurationViewComponentOptionsName,
    MachineConfigurationViewComponentOptions
  )
  .component(
    machineDetailsTabsComponentOptionsName,
    machineDetailsTabsComponentOptions
  )
  .component(
    machineEditFormComponentOptionsName,
    machineEditFormComponentOptions
  )
  .component(
    MachinesChangeViewComponentOptionsName,
    MachinesChangeViewComponentOptions
  )
  .component(
    selectMachineModalComponentOptionsName,
    selectMachineModalComponentOptions
  )
  .component(lookupModalComponentOptionsName, lookupModalComponentOptions)
  .provider(machineDetailTabsServiceName, MachineDetailTabsProvider)
  .provider(LookupManagementServiceName, LookupManagementServiceProvider)
  .service(selectMachineModalServiceName, SelectMachineModalService)
  .service(conversionModalServiceName, ConversionModalService)
  .service(MachinesChangeViewModalServiceName,MachinesChangeViewModalService)
  .service(LookupModalServiceName, LookupModalService);
